import { Collection, CollectionIndexer } from '../types/collection';
import { keys } from './keys';

interface IIndexable<A> {
  [index: number]: A;
}

/**
 * Gets the element at an index from a collection or return `undefined`.
 *
 * @params index if less than zero or null, we search the keys on an object
 * @returns `undefined` if the collection is empty, otherwise `A`.
 */
export function at<A>(index: number | null, collection: Collection<A>): A | undefined {
  const el = isValidIndex(index) ? (collection as IIndexable<A>)[index] : null;

  if (el != null) {
    return el;
  }

  const indices = keys<A>(collection);
  const nextIndex = !isValidIndex(index) ? indices.length - 1 : index;

  const elIndex = indices[nextIndex];

  return index != null ? (collection as CollectionIndexer<A>)[elIndex] : undefined;
}

function isValidIndex(index: number | null): index is number {
  return index != null && index >= 0;
}
